// Scramble — ported verbatim from GolfGamesScorecard's calcScramble
// (utils/scoring.ts). Every member tees off, the team picks the best shot and
// all play from there → one team ball. So the team score on a hole is the
// LOWEST member score that hole; lowest team total wins. (Identical computation
// to Shamble in this app — Scramble differs only in how you get there on the
// course, not in the arithmetic.)
export function calcScramble(teams) {
  return (teams || [])
    .map((team) => {
      const teamScore = Array.from({ length: 18 }, (_, hole) => {
        const scores = team.map((p) => p.scores[hole]).filter((s) => s !== null && s !== undefined)
        return scores.length ? Math.min(...scores) : null
      })
      return { team, teamScore, total: teamScore.reduce((s, v) => s + (v ?? 0), 0) }
    })
    .sort((a, b) => a.total - b.total)
}
